import type { EntityValue, Kind, LocalRecord, Note, Task } from './model';

type TrashRecord = Pick<LocalRecord, 'kind' | 'value'> & { deleted?: boolean };

export function isAvailableRecord(record: TrashRecord) {
  return !record.deleted && !('trashed' in record.value && record.value.trashed);
}

export function isWorkspaceTrash(record: TrashRecord) {
  return (
    !record.deleted &&
    ['task', 'note'].includes(record.kind) &&
    'trashed' in record.value &&
    Boolean(record.value.trashed)
  );
}

// Keep only identity/completion metadata needed by links and earned goal credit.
// The permanent deleted flag prevents stale devices from restoring the content.
export function deletedValue(kind: Kind, value: EntityValue): EntityValue {
  if (kind === 'task') {
    const task = value as Task;

    return {
      title: 'Deleted task',
      trashed: true,
      today: false,
      done: task.done,
      completedOn: task.completedOn ?? null,
      noteId: null,
      steps: [],
      stoppingPoint: '',
    } satisfies Task;
  }

  if (kind === 'note') {
    return {
      title: 'Deleted note',
      trashed: true,
      area: 'Archive',
      parentId: null,
      content: { type: 'doc', content: [] },
      updatedAt: (value as Note).updatedAt,
    } satisfies Note;
  }

  if (kind === 'vault') {
    return { title: 'Deleted', username: '', password: '', url: '', notes: '', trashed: true };
  }

  throw new Error('Only trashed notes, tasks and vault entries can be permanently deleted');
}
